var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "pilots-requirements-container" }, [
      _c("div", { staticClass: "pilots-requirements" }, [
        _c("div", { staticClass: "image" }, [
          _c("img", {
            attrs: { src: _vm.$t("registration.pilots.travel-tailor-made-img") }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "content-box flex" }, [
            _c("h2", [_vm._v("1")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.$t("registration.pilots.travel-tailor-made.desc-1"))
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-box flex" }, [
            _c("h2", [_vm._v("2")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.$t("registration.pilots.travel-tailor-made.desc-2"))
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-box flex" }, [
            _c("h2", [_vm._v("3")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.$t("registration.pilots.travel-tailor-made.desc-3"))
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-box flex" }, [
            _c("h2", [_vm._v("4")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.$t("registration.pilots.travel-tailor-made.desc-4"))
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c7481e2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c7481e2","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/PilotsRequirements.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2c7481e2","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/PilotsRequirements.vue
// module chunks = 1 2 3